<template>
  <!-- ※HeroSliderで代替。必要なくなるはず 20221219 -->
  <div class="slider-banner" :class="'slider-banner--length' + length">
    <!-- バナーが１つの場合 -->
    <template v-if="length === 1">
      <a v-if="infoBanner[0].url" :href="infoBanner[0].url" class="slider-banner__link" :target="setTarget(infoBanner[0].url)">
        <img class="slider-banner__img" :src="infoBanner[0].img_url" :alt="infoBanner[0].memo" />
      </a>
      <div v-else class="slider-banner__box">
        <img class="slider-banner__img" :src="infoBanner[0].img_url" :alt="infoBanner[0].memo" />
      </div>
    </template>
    <!-- バナーが複数の場合 -->
    <template v-else>
      <swiper
        ref="infoBannerSwiper"
        :options="swiperOptions"
      >
        <swiperSlide v-for="(item, index) in infoBanner" :key="index">
          <a v-if="item.url" :href="item.url" class="slider-banner__link" :target="setTarget(item.url)">
            <img class="slider-banner__img" :src="item.img_url" :alt="item.memo" />
          </a>
          <div v-else class="slider-banner__box">
            <img class="slider-banner__img" :src="item.img_url" :alt="item.memo" />
          </div>
        </swiperSlide>
      </swiper>
      <div class="swiper-button-prev">
        <ArrowIcon width="22" color="#fff" direction="left" />
      </div>
      <div class="swiper-button-next">
        <ArrowIcon width="22" color="#fff" direction="right" />
      </div>
      <div class="swiper-pagination"></div>
    </template>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ArrowIcon from '@/utvStore/components/common/icon/ArrowIcon'

export default {
  name: "SliderBanner",
  components: {
    swiper,
    swiperSlide,
    ArrowIcon,
  },
  props: {
    infoBanner: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      // スライドのオプション
      swiperOptions: {
        autoplay: {delay: 3000},
        autoHeight: true,
        spaceBetween: -20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      },
    }
  },
  computed: {
    // スライダー
    swiper() {
      return this.$refs.infoBannerSwiper.swiper
    },
    // バナーの数を返す
    length() {
      return this.infoBanner.length
    }
  },
  methods: {
    /**
     * 内部リンク・外部リンクを判定
     * （外部リンクなら target="_blank" となる様にする）
     */
    setTarget (url) {
      // urlと同じドメイン
      if (url.indexOf(window.location.hostname) !== -1) {
        return ''
      // 先頭が http(s):// 始まりではない
      } else if (/^(https?:\/\/)/.test(url) === false) {
        return ''
      // それ以外は外部リンク
      } else {
        return '_blank'
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.slider-banner {
  padding: 0;
  margin: 0 auto 20px;
  position: relative;
  &--length1 {
    padding: 0 20px;
  }
  &__link,
  &__box {
    display: block;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  }
  &__img {
    max-width: 100%;
    vertical-align: middle;
  }
}
</style>

<style lang="scss">
.slider-banner {
  .swiper-container {
    padding-bottom: 18px;
  }
  .swiper-slide {
    padding: 0 20px;
  }
  .swiper-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.3s;
    line-height: 1;
  }
  .swiper-pagination-bullet {
    margin: 0 6px;
    background: #fff;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: #AAB2BD;
  }
  .swiper-button-prev,
  .swiper-button-next {
    background: rgba(#656D78, 0.5);
    width: auto;
    height: auto;
    transform: translate(0, calc(-50% - 9px));
    margin: 0;
    padding: 7px;
    font-size: 0;
    border-radius: 100px;
  }
  .swiper-button-prev { left: 5px;}
  .swiper-button-next { right: 5px;}
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SliderBanner.vue